<form [formGroup]="filterForm" (keydown.enter)="handleEnterKey()" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout.lt-md="column" fxLayoutGap="20px">
    <inscricoes-autocomplete-key-value
      *ngIf="!shouldHideConcursoFilter"
      [options]="concursosAtivos"
      keyProperty="id"
      valueProperty="titulo"
      label="Filtrar por concurso"
      placeholder="Digite para buscar..."
      formControlName="concurso"
      appearance="outline"
      fxFlex>
    </inscricoes-autocomplete-key-value>

    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Filtrar por papel do examinador</mat-label>
      <mat-select name="papel" formControlName="papel">
        <mat-option>TODOS</mat-option>
        <mat-option value="TITULAR">Titular</mat-option>
        <mat-option value="SUPLENTE">Suplente</mat-option>
        <mat-option value="PRESIDENTE">Presidente</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout.lt-md="column" fxLayoutGap="20px">
    <mat-form-field appearance="outline" fxFill>
      <mat-icon matPrefix>search</mat-icon>
      <mat-label>Pesquisar por: nome, email, matrícula ou unidade</mat-label>
      <input
        matInput
        type="text"
        name="nome"
        formControlName="nome"
        placeholder="Digite parte do nome, email, matrícula ou unidade e pressione ENTER para pesquisar"
        (keydown.enter)="$event.preventDefault()" />
      <button
        *ngIf="filterForm.value.nome"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="handleClearSearchInput()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
</form>
